import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OwnershipTypeDto,AddressBookDto, BatchDto, LessorsDto } from '@cradua/data';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'cradua-payment-approval',
  templateUrl: './payment-approval.component.html',
  styleUrls: ['./payment-approval.component.css']
})
export class PaymentApprovalComponent implements OnInit {

  @Input() ownershiptypes: OwnershipTypeDto[];
  @Input() quantums: any[];
  @Input() lessors: LessorsDto[];
  @Input() addressbooks: AddressBookDto[];
  @Input() batches: BatchDto[];
  @Input() LandTitleSerialNo: string;
  @Output() addressssearchevent = new EventEmitter();
  @Output() submitevent = new EventEmitter();

  filteredLessors: LessorsDto[] = [];
  paymentstatus = ['PENDING', 'PAID'];
  ownerselected: string;
  selectall = false;
  paymentForm: FormGroup;
  status = '';
  listView = true;
  gridView = false;

  constructor(private fb: FormBuilder, public datepipe: DatePipe, private matSnackBar: MatSnackBar) {}

  ngOnInit(): void {
    this.addPayment();
    }

    ngOnChanges(): void {
    this.batches = this.batches.sort( (a, b) => +a.BatchName - +b.BatchName);
    this.lessors = this.lessors.filter( lessor => lessor.LandTitleSerialNo === this.LandTitleSerialNo)
    setTimeout(() => {
      this.selectPaymentOption(status);
    }, 100);
    }

    onList() {
      this.listView = true;
      this.gridView = false;
    }

    onGrid() {
      this.gridView = true;
      this.listView = false;
    }

  addPayment() {
  this.paymentForm = this.fb.group({
    PaymentType: [''],
    ownerName: [''],
    LandType:[''],
    ItemName: [''],
    Area: [''],
    Qty: [''],
    Rate: [''],
    Amount: [''],
    NegotiatedAmount: [''],
    PaymentStatus:['', Validators.required],
    ApprovalRemarks: [''],
    OwnershipTypeName: [''],
    MeasureName: [''],
    TerrianName: [''],
    PaymentDate: [''],
    BatchId: [''],
    id: [''],
    LandTitleSerialNo: this.LandTitleSerialNo
  })
}
  selectaddressbook(book: AddressBookDto) {
    this.selectall = false;
    this.ownerselected = book.id;
    this.filteredLessors = this.lessors.filter(lessor => lessor.Owners === book.id && lessor.LandTitleSerialNo === this.LandTitleSerialNo);
    // this.addPayment();
    // this.setpayment();
  }

  selectLessor(lessor) {
    const Qty  = !lessor.Qty ? 0 : lessor.Qty;
    const date  = !lessor.PaymentDate ? lessor.PaymentDate : this.datepipe.transform(lessor.PaymentDate, 'yyyy-MM-dd');
    this.paymentForm.patchValue(lessor);
    this.paymentForm.patchValue({
      Qty: Qty,
      PaymentDate: date
    });
  }

  // setpayment() {
  //   const control = this.paymentForm.controls.Lessors as FormArray;
  //   this.clearFormArray(control)
  //   this.filteredLessors.forEach(e => {
  //     console.log
  //   const Qty  = !e.Qty ? 0 : e.Qty;
  //   let latest_date = this.datepipe.transform(e.PaymentDate, 'yyyy-MM-dd');
  //   control.push(this.fb.group({
  //     PaymentType: e.PaymentType,
  //     ownerName: e.ownerName,
  //     LandType: e.LandType,
  //     ItemName: e.ItemName,
  //     Area: e.Area,
  //     Qty: Qty,
  //     Rate: e.Rate,
  //     Amount: e.Amount,
  //     NegotiatedAmount: e.NegotiatedAmount,
  //     PaymentStatus: e.PaymentStatus,
  //     ApprovalRemarks: e.ApprovalRemarks,
  //     OwnershipTypeName: e.OwnershipTypeName,
  //     MeasureName: e.MeasureName,
  //     TerrianName: e.TerrianName,
  //     PaymentDate: latest_date,
  //     BatchId: e.BatchId,
  //     id: e.id
  //   }));
  //   })
  // }

    // method to reset form array after selection
    clearFormArray = (formArray: FormArray) => {
      const control = this.paymentForm.controls.Lessors as FormArray;
      while (formArray.length !== 0) {
        control.removeAt(0);
      }
    };

  calcAmount() {
   const amount = {
    totalNeg: 0,
    totalAmt: 0,
    }

    if(this.filteredLessors.length > 0) {
      this.filteredLessors.map(a => {
        amount.totalAmt += a.Amount;
        amount.totalNeg += a.NegotiatedAmount;
       });
    }

    return amount;
  }

  searchAddressBook(name) {
    this.addressssearchevent.emit(name);
  }

  filterByStatus(status) {
    this.status = status;
    if(status === 'ALL') {
      this.selectPaymentOption(status)
    } else {
    this.selectall = false;
      this.ownerselected ?
      this.filteredLessors = this.lessors.filter(l => l.PaymentStatus === status &&  l.Owners === this.ownerselected && (l.Payment === 'Acreages' || l.Payment === 'Surface')):
      this.filteredLessors = this.lessors.filter(l => l.PaymentStatus.includes(status) && (l.Payment === 'Acreages' || l.Payment === 'Surface'))
      // .sort((a, b) => new Date(b.PaymentDate).getTime() - new Date(a.PaymentDate).getTime());
      // this.setpayment();
    //  this.addPayment();

    }
  }

  selectPaymentOption(status) {
    if(status === 'ALL' && this.ownerselected) {
    this.selectall = false;
      this.filteredLessors = this.lessors.filter(l =>l.Owners === this.ownerselected)
      // .sort((a, b) => new Date(a.PaymentDate).getTime() - new Date(b.PaymentDate).getTime());
    } else {
      this.selectall = true;
      this.filteredLessors = this.lessors.filter(l => (l.PaymentStatus.includes('PAID') ||
                                                      l.PaymentStatus.includes('APPROVED') ||
                                                      l.PaymentStatus.includes('REJECTED') ||
                                                      l.PaymentStatus.includes('PENDING'))
                                                      && (l.Payment === 'Acreages' || l.Payment === 'Surface')
                )
      // .sort((a, b) => new Date(a.PaymentDate).getTime() - new Date(b.PaymentDate).getTime());
    }
    // this.addPayment();

  }

  selectAll() {
    this.ownerselected = null;
    this.selectall = this.selectall ? false : true;
    if(this.selectall) {
      this.selectPaymentOption('ALL')
    } else {
      this.filteredLessors = [];
      // this.setpayment();
    }

  }


  onSubmit(data) {
  const lessors = []
 data.forEach(e => {
    if(e.PaymentStatus !== 'PENDING') {
      lessors.push( {
        PaymentDate: e.PaymentDate,
        ApprovalRemarks: e.ApprovalRemarks,
        BatchId: e.BatchId,
        PaymentStatus: e.PaymentStatus,
        id: e.id
      });
    }
  });

  const newdata = {Lessors: lessors};
    this.submitevent.emit(newdata);
  }

  savePayment(lessor) {
    let message = ''

      if(!lessor.PaymentStatus) {
        message = 'please fill all required fields!';
      }


    if(message) {
     return this.matSnackBar.open(message, 'Exit', {duration: 3000});
    }

        this.addPayment();
        this.filteredLessors = this.filteredLessors.filter(les => les.id !== lessor.id);
        this.filteredLessors.unshift(lessor);


  }

}
